import { unreachableFallback } from './unreachableFallback';
export const hasOrderedApprovalSteps = ({
  approvalType
}) => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
    case 'LANDING_PAGE':
    case 'SITE_PAGE':
    case 'BLOG_POST':
    case 'DEAL':
    case 'KNOWLEDGE_ARTICLE':
    case 'QUOTE':
    case 'SOCIAL_BROADCAST':
      return true;
    case 'CONNECTED_APP':
      return false;
    default:
      return unreachableFallback(approvalType, true);
  }
};